import {connectRouter} from 'connected-react-router';
import {combineReducers} from 'redux';
import {createBrowserHistory} from 'history';
import cwa from './cwa-reducer';
import rehydrate from './rehydrate-reducer';

const history = createBrowserHistory();
const singlePageApp = combineReducers({
  cwa,
  rehydrate,
  router: connectRouter(history),
});

const rootReducer = (state, action) => {
  let s = state;
  if (action.type === 'LOGOUT') {
    s = {rehydrate: state.rehydrate, router: state.router};
  }
  return singlePageApp(s, action);
};

export default rootReducer;
